module.exports = __webpack_public_path__ + "static/media/sensual_sax_thumb_home.a753b9dd.jpg";